export { FaviconTags } from './next/components/FaviconTags'
export { iconMetadata } from './next/metadata'
export { getAssetDefaults, setDynamicFavicon, FaviconAsset } from './lib/util'
export * from '../types'
